import {
  CollatableEntityCollections,
  CollatableEntityCollectionsRepository,
  defaultEntityCollation,
  EntityCollation
} from '../root-store-common'
import { StateRepository } from '@angular-ru/ngxs/decorators'
import { Selector, State } from '@ngxs/store'
import {
  createEntityCollections,
  EntityDictionary
} from '@angular-ru/cdk/entity'
import { Injectable } from '@angular/core'
import { EMPTY, Observable } from 'rxjs'
import { InsightDTO } from '../../shared/model/insight.model'
import { InsightState } from '../insight/insight.state'
import { PatientState } from '../patient/patient.state'
import { FileState } from '../file/file.state'
import { DepartmentState } from '../department/department.state'
import { PatientDTO } from '../../shared/model/patient'
import { FileDTO } from '../../shared/model/file'
import { DepartmentDTO } from '../../shared/model/permission.model'
import { DepartmentFilter } from '../../shared/model/departments.model'
import { BffPatient } from '../../shared/model/bff/patient'

export const insightFeatureName = 'insights'

@StateRepository()
@State<CollatableEntityCollections<InsightDTO>>({
  name: insightFeatureName,
  defaults: {
    ...createEntityCollections(),
    ...defaultEntityCollation()
  }
})
@Injectable()
export class InsightsState extends CollatableEntityCollectionsRepository<
  InsightDTO,
  EntityCollation
> {
  constructor() {
    super()
  }

  @Selector([
    InsightState,
    InsightState.entities,
    PatientState.entities,
    DepartmentState.currentDepartments
  ])
  public static activeInsights(
    state: CollatableEntityCollections<InsightDTO>,
    insights: EntityDictionary<string, InsightDTO>,
    patient: EntityDictionary<string, BffPatient>,
    currentDepartments: DepartmentDTO[] | null
  ): InsightDTO[] {
    let patients = Object.values(patient)
    if (currentDepartments) {
      patients = patients.filter(
        patient =>
          patient.department &&
          currentDepartments
            .map(department => department.id)
            .includes(patient.department.id)
      )
    }
    const currentInsights: InsightDTO[] = []
    Object.values(insights).forEach(insight => {
      if (insight.patient && insight.patient.id) {
        const patient: BffPatient | undefined = Object.values(patients).find(
          p => p.id === insight.patient?.id
        )
        if (patient) {
          currentInsights.push({
            ...insight
          })
        }
      }
    })
    return currentInsights.filter(
      insight => insight.insightStatus === 'ongoing'
    )
  }

  protected setPaginationSetting(): Observable<any> {
    return EMPTY
  }

  protected loadEntitiesFromBackend(
    ids: string[] | undefined
  ): Observable<void> {
    return EMPTY
  }
}
